<template>
  <v-app id="inspire" theme="light">
    <app-bar></app-bar>
    <navigation v-if="lgAndUp"></navigation>

    <v-main
      :style="{
        backgroundColor: theme.current.value.colors.backgroundDark,
      }"
    >
      <v-container fluid>
        <slot />
      </v-container>
    </v-main>

    <scroll-to-top-fab />

    <calendar-snackbar />
  </v-app>
</template>

<script setup>
import { onMounted } from "vue";
import { useDisplay, useTheme } from "vuetify";
import CalendarSnackbar from "../components/CalendarSnackbar.vue";

const { lgAndUp } = useDisplay();
const theme = useTheme();

onMounted(() => {
  theme.change("light");
});
</script>

<style scoped>
.layout-container {
  max-width: 1390px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
